import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/portal/academy")({
  component: AcademyLayout,
});

function AcademyLayout() {
  return <Outlet />;
}